export const endpoints = {
  shareSummaryLink: 'LocalBusiness/sendSummary',
  getSessionIdById: 'LocalBusiness/getSessionId'
}